import React from "react";
import PageHeader from "../../PageHeader";
import ViewGenerateRegistrationLink from "./ViewGenerateRegistrationLink";
import { ReactComponent as RegistrationLinkIcon } from "../../../images/registrationlinkimage/registrationlinkimage.svg";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import useStyles from "../../../../styles";

function GenerateRegistrationLink() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      pageicon: <RegistrationLinkIcon />,
      mainheading: "Registration Link",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      addbtntext: "Generate New Registration Link",
      addbtnicon: <AddIcon />,
      addbtnstyle: "bluebtn",
      path: "/admin/generateregistrationlink",
    },
  ];
  return (
    <div className={`${classes.p1} ${classes.pb0}`}>
      <PageHeader Heading={Heading} />
      <ViewGenerateRegistrationLink />
    </div>
  );
}
export default GenerateRegistrationLink;
